import React, { useEffect, useState, useContext } from 'react';
import { GetAvailableDates, getOrderDetails, GetAvailableTimes,GetAvailableTickets,GetAvailableReplacementTickets, getAccountFees,resendOrder } from '../api-funcs';
import { useCart, usePromoCodeInput, EventContext } from '../CartContext';
import { Container, Row, Col, Card, Button, CardBody } from 'react-bootstrap';
import { useParams, useNavigate} from 'react-router-dom';
import { Link } from 'react-router-dom';
import Cart from '../mini-cart';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import MyDatePicker from './DatePicker';

function OrderDetails () {
    const {globalEventId, settings} = useContext(EventContext);
    const { updateCartContents } = useCart();
    const {accountToken} = useContext(EventContext);
    const { promoCodeInput, setPromoCode } = usePromoCodeInput();

    const navigate = useNavigate();

    const [orderInfo, setOrderInfo] = useState([]);
    const [showModifyOrder, setShowModifyOrder] = useState(false);
    const [ticketDates, setTicketDates] = useState();
    const [selectedDate, setSelectedDate] = useState([]);
    const [ticketTimes, setTicketTimes]= useState();

    // Only show/select items users can actually pick
    const selectableDates = React.useMemo(
    () => (ticketDates ?? []).filter(d => d.NUMTICKETS > 0),
    [ticketDates]
    );
    const selectableTimes = React.useMemo(
    () => (ticketTimes ?? []).filter(t => t.TICKET_QUANTITY > 0),
    [ticketTimes]
    );

    const [selectedTime, setSelectedTime] = useState([]);
    const [tickets, setTickets]= useState();
    const [selectedTicket, setSelectedTicket] = useState([]);
    const [workingIndex, setWorkingIndex] = useState(0);
    const [feeTicket, setFeeTicket] = useState();
    const [orderChangeDate, setOrderChangeDate] = useState();
    const [orderChangeTime, setOrderChangeTime] = useState();

    const [orderPrice, setOrderPrice] = useState(0);
    const [newOrderPrice, setNewOrderPrice] = useState(0);
    const [totalFees, setTotalFees] = useState(0);
    const [modifiedOrder, setModifiedOrder] = useState();

    const [isSent, setIsSent] = useState(false);

    const [disableModify, setDisableModify] = useState(false);

    let dateBlock = '';
    let header = '';
    let ticketDate = '';
    let ticketTime = '';

    const {order_num} = useParams();

    async function fetchOrderDetails() {
        const orderData = await getOrderDetails(accountToken,order_num);
        
        if (orderData === 403)
            navigate('/my-account');

        if (!orderData)
            return

        setOrderInfo(orderData);

        //set same promo code as original order
        if (orderData[0]?.EP_NAME)
            setPromoCode(orderData[0]?.EP_NAME);
    }
    
    //initial load of cart data on mount
    useEffect(() => {

      fetchOrderDetails();

    }, []);

    // "Oct. 16, 2025 08:00 PM"  -> Date (local TZ)
    function parseTicketDate(ticketDateStr) {
    if (!ticketDateStr) return null;
    // Extract parts: Mon., DD, YYYY HH:MM AM/PM
    const m = ticketDateStr.match(
        /^([A-Za-z]{3})\.?\s+(\d{1,2}),\s+(\d{4})\s+(\d{1,2}):(\d{2})\s+(AM|PM)$/i
    );
    if (!m) return null;

    const [, monAbbrRaw, dStr, yStr, hStr, minStr, ampm] = m;
    const monAbbr = monAbbrRaw.replace('.', '').toLowerCase();
    const monthMap = {
        jan:0, feb:1, mar:2, apr:3, may:4, jun:5,
        jul:6, aug:7, sep:8, oct:9, nov:10, dec:11
    };
    const month = monthMap[monAbbr];
    if (month == null) return null;

    let hour = parseInt(hStr, 10);
    const minute = parseInt(minStr, 10);
    // 12-hour → 24-hour
    if (/pm/i.test(ampm) && hour !== 12) hour += 12;
    if (/am/i.test(ampm) && hour === 12) hour = 0;

    const year = parseInt(yStr, 10);
    const day = parseInt(dStr, 10);

    // Local time (uses user’s TZ, e.g., America/Toronto)
    return new Date(year, month, day, hour, minute, 0, 0);
    }

    useEffect(() => {
    if (!Array.isArray(orderInfo) || orderInfo.length === 0) {
        setDisableModify(false);
        return;
    }

    console.log('cutoff hours',settings.ES_CHANGE_CUTOFF_HOURS);
    const now = new Date();
    const cutoffMs = now.getTime() + settings.ES_CHANGE_CUTOFF_HOURS * 60 * 60 * 1000;

    // Disable if ANY non-voided type-1 ticket is at or before cutoff
    const blocked = orderInfo.some(it => {
        //if (it?.TICKET_TYPE !== 1) return false;   // tickets only
        //if (it?.VOIDED) return false;              // skip voided
        const dt = parseTicketDate(it?.TICKET_DATE); // your parser from before
        if (!dt) return false;
        const t = dt.getTime();
        return t <= cutoffMs;  // <= now+24h covers past and the next 24h
    });

    setDisableModify(blocked);
    }, [orderInfo]);


    //Modify Order - Date Picker
    useEffect(() => {
        const fetchPickerTimes = async() => {
            if (orderChangeDate) {
                const availableTimes = await GetAvailableTimes(globalEventId,orderChangeDate,'',0);
            
                if (availableTimes)
                    setTicketTimes(availableTimes);
            }
        }

        fetchPickerTimes();
    },[orderChangeDate]);

    //Modify Tickets - date selector
    useEffect(() => {
        const fetchTimes = async() => {
            if (selectedDate && selectedDate[workingIndex]) {
                const availableTimes = await GetAvailableTimes(globalEventId,selectedDate[workingIndex].EVENTDAY,'',0);
            
                if (availableTimes)
                    setTicketTimes(availableTimes);
            }
        }

        fetchTimes();
    },[selectedDate[workingIndex], selectedDate]);

    //Modify Tickets - time selector
    useEffect(() => {
        const fetchTickets = async() => {
            if (selectedTime && selectedTime[workingIndex]) {
                const newDateTime = selectedDate[workingIndex].EVENTDAY.substring(0, 10)+' '+selectedTime[workingIndex].EVENT_DATE.substring(11, 16)
                const timeZone = 'AMERICA/TORONTO';
                
                const availableTickets = await GetAvailableTickets(globalEventId,newDateTime,timeZone,'',0);
                
                if (availableTickets)
                    setTickets(availableTickets);
            }
        }

        fetchTickets();
    },[selectedTime[workingIndex], selectedTime]);

    //Modify Order - time selector
    useEffect(() => {
        const fetchOrderTickets = async() => {
            if (orderChangeTime) {
                
                const newDateTime = orderChangeTime.EVENT_DATE.substring(0,16);
                const timeZone = 'AMERICA/TORONTO';
//                const ticketOptions = await GetAvailableTickets(globalEventId,newDateTime,timeZone,promoCodeInput,0);
                const ticketOptions = await GetAvailableReplacementTickets(globalEventId,newDateTime,timeZone,promoCodeInput,0);
                
                if (ticketOptions) {
                    //build new order from old order
                    const newOrder = [];
                    
                    let origPrice=0;
                    let newPrice=0;
                    let feePrice=0;
                    let cartTicket;
                    let newTicketPrice = 0;

                    for (const item of orderInfo) {
                        newTicketPrice = 0;

                        //regular tickets
                        if (item.TICKET_TYPE === 1) {
                            cartTicket = { ...ticketOptions.find(oneTicket => oneTicket.definition_id === item.TICKET_DEF) };

                            origPrice += item.PRICE;
                            if (cartTicket.promo_price && (cartTicket.promo_price < cartTicket.base_price)) {
                                newPrice += Number(cartTicket.promo_price);
                                newTicketPrice = Math.max(0,parseFloat(cartTicket.promo_price) - parseFloat(item.PRICE));
                            }
                            else {
                                newPrice += Number(cartTicket.base_price);
                                newTicketPrice = Math.max(0,parseFloat(cartTicket.base_price) - parseFloat(item.PRICE));
                            }

                            feePrice+= feeTicket.base_price;
    
                            cartTicket.cart_qty = 1;
                            cartTicket.base_price = newTicketPrice;
                            cartTicket.replacement = item.TICKET_NUM;
                        
                            newOrder.push(cartTicket);
                            newOrder.push(feeTicket);
                        }
                        //merchandise
                        else {
                            cartTicket = {
                                            ticket_type:item.TICKET_TYPE, 
                                            definition_id:item.TICKET_DEF,
                                            ticket_id:item.TICKET_ID, 
                                            cart_qty:1, 
                                            base_price:item.PRICE, 
                                            replacement: item.TICKET_NUM};
                            newOrder.push(cartTicket);
                        }
                
                
                    }
 
                    setOrderPrice(origPrice);
                    setNewOrderPrice(newPrice);
                    setTotalFees(feePrice);
                
                    setModifiedOrder(newOrder);
                    
                }
            }
        }

        fetchOrderTickets();
    },[orderChangeTime]);
    
    async function emailOrder() {
        const emailResult = await resendOrder(accountToken,order_num,globalEventId);

        if (emailResult.success === true)
            setIsSent(true);
            
    }

    //when user wants to modify their order, display the form
    async function displayModifyOrder() {
        const dateInfo = await GetAvailableDates(globalEventId,'',0);

        if (dateInfo) {
            //strip out dates with 0 tickets
            const filteredDates = dateInfo.filter(item => item.NUMTICKETS > 0);
            setTicketDates(filteredDates);

            const feeTicketData = await getAccountFees(accountToken,globalEventId);
            setFeeTicket(feeTicketData[0]);
        }

        setShowModifyOrder(true);
    }

    //Modify Tickets - store the date the user picks from the dropdown
    // value = EVENTDAY (string), index = rowIndex
    const handleDateChange = (dateId, index) => {
    const picked = (ticketDates ?? []).find(d => d.EVENTDAY === dateId) || null;
    setSelectedDate(prev => {
        const next = [...prev];
        next[index] = picked;
        return next;
    });
    setWorkingIndex(index);
    };

    //Modify Order - store the user selection from the date picker
    const handlePickerChange = (data) => {
        const formattedDate = data + 'T04:00:00.000Z';
        setOrderChangeDate(formattedDate);
    }
    
    //Modify Order - store the user time selection
    // value = EVENT_TICKET_ID
    const handleOrderTimeChange = (timeId) => {
    const picked = (selectableTimes ?? []).find(t => String(t.EVENT_TICKET_ID) === String(timeId)) || null;
    setOrderChangeTime(picked);
    };

        //Modify Tickets - store the time the user picks from the dropdown
    // value = EVENT_TICKET_ID (string/number), index = rowIndex
    const handleTimeChange = (timeId, index) => {
    const picked = (selectableTimes ?? []).find(t => String(t.EVENT_TICKET_ID) === String(timeId)) || null;
    setSelectedTime(prev => {
        const next = [...prev];
        next[index] = picked;
        return next;
    });
    setWorkingIndex(index);
    };

    //Modify Tickets - store the ticket the user picks from the dropdown
    const handleTicketChange = (value, index) => {
        setSelectedTicket((prevTickets) => {
          const newTickets = [...prevTickets];
          newTickets[index] = tickets[value];
          return newTickets;
        });

        setWorkingIndex(index);
    };
    
    //Modify Tickets - add a single ticket to the cart
    const handleAddtoCart = async (value) => {
        //calculate the price difference.  No refunds if original price was more.
        //use a new variable for the new ticket so a user can't keep adding to cart
        //which would continue discounting base_price of the original.
        let cartTicket = { ...selectedTicket[value] };
        const newTicketPrice = Math.max(0,parseFloat(selectedTicket[value].base_price) - parseFloat(orderInfo[value].PRICE));
        cartTicket.cart_qty = 1;
        cartTicket.base_price = newTicketPrice;
        cartTicket.replacement = orderInfo[value].TICKET_NUM;

        let completeCart = [];
        completeCart.push(cartTicket);
        completeCart.push(feeTicket);

        await updateCartContents(globalEventId,completeCart);
    }
    
    //Modify Order - add the full order to the cart
    const handleModifyOrder = async () => {
        await updateCartContents(globalEventId,modifiedOrder);
    }

  return (
    <>
    <Container className='mt-4'>
        <Row>
          <Col className='text-start mb-4'>
            <Link to="/my-account" style={{ textDecoration: 'none', fontSize:'12px' }}>{'<< Back to orders'}</Link>
          </Col>
        </Row>
        <Row>
            <Col>
                <h3 className="text-start order-detail-heading">Order Details</h3>
            </Col>
        </Row>
      <Row>
        <Col>
            <Card>
                <CardBody>

                    <Row>
                        <Col xs={12} className='text-start'>
                            <Row>
                                <Col className='fw-bold'>Customer Name: </Col>
                                <Col>{orderInfo[0]?.CUST_NAME}</Col>
                            </Row>
                            <Row>
                                <Col className='fw-bold'>Order Number:</Col>
                                <Col>{orderInfo[0]?.ORDER_NUM}</Col>
                            </Row>
                            <Row>
                                <Col className='fw-bold'>Order Date:</Col>
                                <Col>{orderInfo[0]?.ORDER_DATE}</Col>
                            </Row>
                            <Row>
                                <Col className='fw-bold'>Order Total:</Col>
                                <Col>${orderInfo[0]?.ORDER_TOTAL}</Col>
                            </Row>
                            <Row>
                                <Col className='fw-bold'>Payment Method:</Col>
                                <Col>{orderInfo[0]?.PAYMENT_METHOD}</Col>
                            </Row>
                            <Row>
                                <Col className='fw-bold'>Payment Info:</Col>
                                <Col>{orderInfo[0]?.LAST4}</Col>
                            </Row>
                        </Col>
                    </Row>
                    </CardBody>
            </Card>
        </Col>
      </Row>
      {!showModifyOrder ? (
        <>
      <Row className="mt-4">
      <Col xs={12} className="mb-3">
          <Card>
          <Card.Body>
              <Card.Title className="text-start">Tickets</Card.Title>
              {orderInfo
              .map((item,index) => {
                  item.rowId = '1-'+index;

                if (item.ticket_type === 1) {

                    if (dateBlock != item.TICKET_DATE) {
                        dateBlock = item.TICKET_DATE;
                        ticketDate = item.TICKET_DATE.substring(0, 13); 
                        ticketTime = item.TICKET_DATE.substring(14, 22); 
                        header = ticketHeader(ticketDate,ticketTime,item);
                    }
                    else
                        header = '';
                }
                else
                    header = '';

                  return (
                  <>
                    {header}
                    <Row key={1 - index} className={item.VOIDED ? 'voided' : ''}>
                        <Col xs={5} className="text-start cartColDetail">{item.NAME}</Col>
                        <Col xs={4} className="text-end cartColDetail">{item.TICKET_DATE}</Col>
                        <Col xs={3} className="text-end cartColDetail">${item.PRICE.toFixed(2)}</Col>
                    </Row>

                  </>
                  );
              })}

                <Row className='mt-4'>
                    <Col xs={9} className='text-end fw-bold'>Sub-Total:</Col>
                    <Col xs={3} className="text-end cartColDetail">${Number(orderInfo?.[0]?.SUBTOTAL ?? 0).toFixed(2)}</Col>
                </Row>
                <Row>
                    <Col xs={9} className='text-end fw-bold'>Tax:</Col>
                    <Col xs={3} className="text-end cartColDetail">${Number(orderInfo?.[0]?.TAX ?? 0).toFixed(2)}</Col>
                </Row>
                <Row>
                    <Col xs={9} className='text-end fw-bold'>Service Fees:</Col>
                    <Col xs={3} className='text-end cartColDetail'>${Number(orderInfo?.[0]?.FEES ?? 0).toFixed(2)}</Col>
                </Row>
                <Row>
                    <Col xs={9} className='text-end fw-bold'>Grand-Total:</Col>
                    <Col xs={3} className='text-end cartColDetail'>${Number(orderInfo?.[0]?.ORDER_TOTAL ?? 0).toFixed(2)}</Col>
                </Row>

          </Card.Body>
          </Card>
      </Col>
      </Row>
      <Row className='pb-5'>
        <Col>
            <Button className='btn-atc' onClick={emailOrder} disabled={isSent}>
                {isSent ? 'Email Sent' : 'Resend Tickets'} 
            </Button>
        </Col>
        <Col>
              <Button className='btn-atc' onClick={displayModifyOrder} disabled={disableModify} >Modify Order</Button>
        </Col>
      </Row>
      </>
      ) : (
        <>
        <Row className='mt-2 mb-2'>
            <Col>
                <Card className='my-account-disclaimer-card'>
                    <Card.Body>
                        {settings.ES_SHOW_CHANGE_FEE === 1 && (
                            <Card.Text className='text-start my-account-disclaimer'>
                                A ${Number(settings.CHANGE_FEE).toFixed(2)} change fee per ticket plus any cost difference from the original ticket will apply. <br/>
                                There are no refunds if the new ticket price is lower than the original ticket price. 
                            </Card.Text>
                        )}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
        <Row>
            <Col>
          <Tabs
            defaultActiveKey="tickets"
            id="uncontrolled-tab-example"
            className="mb-2"
          >
            <Tab eventKey="tickets" title="Modify Order">
                <Row className='mt-4'>
                    <Col xs={12} className='text-start'>
                        <Row>
                            <Col className='fw-bold text-start'><h5>Original Date</h5></Col>
                            <Col className='fw-bold text-start'><h5>New Date</h5></Col>
                        </Row>
                        <Row><hr/></Row>

                            <ModifyOrder 
                            item={orderInfo[0]}
                            dates={ticketDates}
                            times={ticketTimes}
                            onDateChange={handlePickerChange}
                            onTimeChange={handleOrderTimeChange}
                            onAddToCart={handleModifyOrder}
                            orderTotal={orderPrice}
                            newTotal={newOrderPrice}
                            feeTotal={totalFees}
                            />

                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Cart></Cart>
                    </Col>
                </Row>
              
            </Tab>
            {/*<Tab eventKey="passes" title="Modify Individual Tickets">
                <Row className='mt-4'>
                    <Col xs={12} className='text-start'>
                        <Row>
                            <Col className='fw-bold text-start'><h5>Original Ticket</h5></Col>
                            <Col className='fw-bold text-start'><h5>New Ticket</h5></Col>
                        </Row>
                        <Row><hr/></Row>

                        {orderInfo
                        .filter(item => item.VOIDED === null) // Only include items where voided is null
                        .map((item, index) => (
                            <ModifyTicketRow 
                            key={index} // Always add a key when mapping over arrays
                            rowIndex={index}
                            item={item}
                            dates={ticketDates}
                            tickets={tickets}
                            onDateChange={handleDateChange}
                            times={ticketTimes}
                            onTimeChange={handleTimeChange}
                            onTicketChange={handleTicketChange}
                            onAddToCart={handleAddtoCart}
                            newTicket={selectedTicket[index]}
                            changeFee={feeTicket}
                            />
                        ))}

                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Cart></Cart>
                    </Col>
                </Row>
           
            </Tab>
            */}
          </Tabs>
          </Col>
        </Row>
        </>
        )
      }
    </Container>
  </>
)
}

function ticketHeader(inDate,inTime) {
  return (
      <>

      <Row>
      <Col className='text-start'>
          {inDate}, {inTime}
      </Col>
  </Row>
  <Row>
    <Col xs={6} className='text-start fw-bold cartColHeading'>Ticket</Col>
    <Col xs={6} className='text-start fw-bold cartColHeading'>Date/Time</Col>
  </Row>
  </>
  )
}

function ModifyTicketRow({
                        rowIndex,
                        item,
                        dates,
                        times,
                        tickets,
                        onDateChange,
                        onTimeChange,
                        onTicketChange,
                        onAddToCart,
                        newTicket,
                        changeFee
                        }) {

/*    const handleSelectChange = (event) => {
        const value = event.target.selectedIndex - 1;
        onDateChange(value,rowIndex); // Call parent function with selected value
    };
*/
/*    const handleTimeChange = (event) => {
        const value = event.target.selectedIndex - 1;
        onTimeChange(value,rowIndex); // Call parent function with selected value
    };
*/
    const handleTicketChange = (event) => {
        const value = event.target.selectedIndex - 1;
        onTicketChange(value,rowIndex); // Call parent function with selected value
    };

    const handleAddtoCart = (event) => {
        //indicate which Add to Cart is being clicked
        onAddToCart(event.target.value);
    }

    if (item.TICKET_TYPE !== 1)
        return null;    //only show and allow changing of tickets, not change fee, merch, etc.

    return (
    <>
        <Row>
            <Col xs={6} className='mod-ticket-row'>
                {item.ALT_DATE.substring(0,item.ALT_DATE.indexOf('-'))}
            </Col>
            <Col xs={6}>
            <div className="custom-select-wrapper">
<select
  onChange={(e) => onDateChange(e.target.value, rowIndex)}
  className="custom-select"
  defaultValue=""
>
  <option value="" disabled>Date</option>
  {
    dates?.filter(d => d.NUMTICKETS > 0)
      .map((d) => {
        const [year, month, day] = d.EVENTDAY.substring(0, 10).split('-');
        const formattedDate = `${month}-${day}-${year}`;
        return (
          <option key={d.EVENTDAY} value={d.EVENTDAY}>
            {formattedDate}
          </option>
        );
      })
  }
</select>
            </div>
            </Col>
        </Row>
        <Row>
            <Col className='mod-ticket-row'>
                {item.ALT_DATE.substring(item.ALT_DATE.indexOf('-')+1)}
            </Col>
            <Col>
            <div className="custom-select-wrapper">
<select
  onChange={(e) => onTimeChange(e.target.value, rowIndex)}
  className="custom-select"
  defaultValue=""
>
  <option value="" disabled>Time</option>
  {
    times?.filter(t => t.TICKET_QUANTITY > 0)
      .map((t) => {
        const timeString = t.EVENT_DATE.substring(11, 16);
        const [hour, minute] = timeString.split(':').map(Number);
        const formattedTime = new Date(0, 0, 0, hour, minute).toLocaleTimeString('en-US', { 
          hour: 'numeric',
          minute: '2-digit',
          hour12: true 
        });
        return (
          <option key={t.EVENT_TICKET_ID} value={String(t.EVENT_TICKET_ID)}>
            {formattedTime}
          </option>
        );
      })
  }
</select>
            </div>
            </Col>
        </Row>
        <Row>
            <Col xs={6} className='mod-ticket-row'>
                {item.NAME}
            </Col>
            <Col xs={6}>
            <div className="custom-select-wrapper">
                <select onChange={handleTicketChange} className="custom-select">
                    <option disabled selected>Ticket</option>
                    {
                        tickets?.map((item,index) => (
                            <option key={index}>{item.name}</option>
                    ))}
                </select>
            </div>
            </Col>
        </Row>
        <Row className='mt-3'>
            <Col xs={3} className='fw-bold mod-ticket-row'>Orig. Price</Col>
            <Col xs={3} className='fw-bold mod-ticket-row'>New Price</Col>
            <Col xs={2} className='fw-bold mod-ticket-row'>Diff.</Col>
            <Col xs={2} className='fw-bold mod-ticket-row'>Fee</Col>
            <Col xs={2} className='fw-bold mod-ticket-row'>Total</Col>
        </Row>
        <Row>
            <Col xs={3} className='mod-ticket-row'>${item?.PRICE.toFixed(2)}</Col>
            <Col xs={3} className='mod-ticket-row'>
                ${Number(newTicket?.base_price || 0).toFixed(2)}
            </Col>
            <Col xs={2} className='mod-ticket-row'>
                ${Math.max(0, (newTicket?.base_price || 0) - (item?.PRICE || 0)).toFixed(2)}
            </Col>
            <Col xs={2} className='mod-ticket-row'>${changeFee.base_price.toFixed(2)}</Col>
            <Col xs={2} className='mod-ticket-row'>${Math.max(0, newTicket?.base_price - item?.PRICE + changeFee.base_price).toFixed(2)}</Col>
        </Row>
        <Row className='mt-3 mb-4'>
            <Col xs={12} className='text-center'>
                    <Button className='btn-atc' value={rowIndex} onClick={handleAddtoCart}>Add to Cart</Button>
            </Col>
        </Row>
        <Row><hr/></Row>
    </>
    )
}

function ModifyOrder({
                        item,
                        dates,
                        times,
                        onDateChange,
                        onTimeChange,
                        onAddToCart,
                        orderTotal,
                        newTotal,
                        feeTotal
                        }) {

    const [atcButton, setATCButton] = useState(false);
    const [loading, setLoading] = useState(false);

    const handlePickChange = (data) => {
        onDateChange(data);
    }
/*    const handleTimeChange = (event) => {
        const value = event.target.selectedIndex - 1;
        onTimeChange(value); // Call parent function with selected value
    };
*/
    const handleAddtoCart = async () => {
        setLoading(true);
        setATCButton(true);

        await onAddToCart();

        setLoading(false);

    }

    return (
    <>
        <Row>
            <Col xs={6} className='mod-ticket-row'>
                {item.ALT_DATE.substring(0,item.ALT_DATE.indexOf('-'))}
            </Col>
            <Col xs={6}>
            <div className="custom-select-wrapper">
                <MyDatePicker dates={dates} handleSelectChange={handlePickChange} />
            </div>
            </Col>
        </Row>
        <Row>
            <Col className='mod-ticket-row'>
                {item.ALT_DATE.substring(item.ALT_DATE.indexOf('-')+1)}
            </Col>
            <Col>
            <div className="custom-select-wrapper">
<select
  onChange={(e) => onTimeChange(e.target.value)}
  className="custom-select"
  defaultValue=""
>
  <option value="" disabled>Time</option>
  {
    times?.filter(t => t.TICKET_QUANTITY > 0)
      .map((t) => {
        const timeString = t.EVENT_DATE.substring(11, 16);
        const [hour, minute] = timeString.split(':').map(Number);
        const formattedTime = new Date(0, 0, 0, hour, minute).toLocaleTimeString('en-US', { 
          hour: 'numeric',
          minute: '2-digit',
          hour12: true 
        });
        return (
          <option key={t.EVENT_TICKET_ID} value={String(t.EVENT_TICKET_ID)}>
            {formattedTime}
          </option>
        );
      })
  }
</select>
            </div>
            </Col>
        </Row>
        <Row className='mt-3'>
            <Col xs={3} className='fw-bold mod-ticket-row'>Orig. Price</Col>
            <Col xs={3} className='fw-bold mod-ticket-row'>New Price</Col>
            <Col xs={2} className='fw-bold mod-ticket-row'>Diff.</Col>
            <Col xs={2} className='fw-bold mod-ticket-row'>Fee</Col>
            <Col xs={2} className='fw-bold mod-ticket-row'>Total</Col>
        </Row>
        <Row>
            <Col xs={3} className='mod-ticket-row'>${orderTotal.toFixed(2)}</Col>
            <Col xs={3} className='mod-ticket-row'>
                ${Number(newTotal).toFixed(2)}
            </Col>
            <Col xs={2} className='mod-ticket-row'>
                ${Math.max(0, (newTotal || 0) - (orderTotal || 0)).toFixed(2)}
            </Col>
            <Col xs={2} className='mod-ticket-row'>${feeTotal.toFixed(2)}</Col>
            <Col xs={2} className='mod-ticket-row'>${Math.max(0, newTotal - orderTotal + feeTotal).toFixed(2)}</Col>
        </Row>
        <Row className='mt-3 mb-4'>
            <Col xs={12} className='text-center'>
                <Button className='btn-atc' onClick={handleAddtoCart} disabled={atcButton}>
                {loading ? (
                    <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Adding...
                    </>
                ) : (
                    'Add to Cart'
                )}
               </Button>
            </Col>
        </Row>
        <Row><hr/></Row>
    </>
    )
}

export default OrderDetails;
